'use strict';
var core = require('core/search/search');
var $xhr,
    defaultSortTimeout = 30000,
    sortTimeout = defaultSortTimeout;

/**
 *
 * @description Open size and color refinement by default
 */
core.setDefaultRefinementCollapseStates = () => {
  $('.refinement-size, .refinement-color-type').addClass('active');
}

core.setRefinementCollapseStates = status => {

    if (status === 'open') {
        $('.refinement').addClass('active');
    }
    else if (status === 'closed') {
        $('.refinement').removeClass('active');
        $('.refinement').find('button.title').attr('aria-expanded','false');
    }
};

function handleSort(el) {
    var $this = $(el);
    var thisValue = el.value;
    $this.trigger('search:sort', thisValue);
    var errorMsg = $this.data().errorMsg;
    var sortOrder = $this.val().split('srule')[1];
    var url = window.location.toString().split('&srule')[0];
    if (url.includes('srule')) {
        url = window.location.toString().split('?srule')[0];
    }
    var split = url.indexOf('?') !== -1 ? '&' : '?';
    var newUrl = url + split + 'srule' + sortOrder;

    if ($this.hasClass('custom-select')) {
        var newSelection = el.selectedOptions[0];
        $('[name="sort-order"]').find('option[selected="selected"], option:selected').prop('selected',false).removeAttr('selected');
        $(newSelection).prop('selected', true).attr('selected', true);
    } else {
        // deselect previous selection
        $('.sort-order-desktop').removeClass('active');
        $this.addClass('active');
    }

    // Cancel previous request
    $xhr && $xhr.abort && $xhr.abort();

    $xhr = $.ajax({
        url: thisValue,
        data: {
            selectedUrl: thisValue,
            isSortUpdate: true
        },
        method: 'GET',
        timeout: sortTimeout,
        beforeSend: function () {
            $.spinner().start();
        },
        success: function (response) {
            var $productGridElement = $(response).find('.product-grid'); // if response is coming from page designer
            var updatedGridHtml = $productGridElement.length > 0 ? $productGridElement.children() : response;
            $('.product-grid').empty().html(updatedGridHtml);
            history.replaceState(undefined, '', newUrl);
            $('body').trigger('search:sort--success');
            $('body').trigger('ajax:load.ajaxEvents', [$('.product-grid')]);
            // Reset timeout
            sortTimeout = defaultSortTimeout;
            $this.data('sortValueOption', newSelection);
        },
        error: function () {
            displayMessage({ msg: errorMsg, type: 'warning' });
            var sortOption = $this.data('sortValueOption');
            // Reset last active selection
            if (sortOption) {
                $(sortOption).prop('selected', true).attr('selected', true );
            }
            // Extend timeout for subsequent submissions
            sortTimeout += defaultSortTimeout;
        },
        complete: function () {
            $.spinner().stop();
        }
    });
};

core.applyFilter = function () {
    var $xhr;
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .grid-title-reset button.reset, .filter-value button, .swatch-filter button',
        function (event) {
            var category = $(event.currentTarget).closest('.refinement');

            if (category && category.hasClass('refinement-category')) {
                localStorage.setItem('refinement-category', true);
                return;
            }
            //find new attr on Sort if selected, if not use the default
            var selectedSort = $('select[name="sort-order"]').find('option[selected="selected"]');
            if (selectedSort.data('id') != null) {
                var sortingRule = selectedSort.data('id');
            } else {
                var sortingRule = $('select[name="sort-order"] option:selected').data('id');
            }
            //create a new url with the correct preferences
            if ($(this).data('href').includes('srule')) {
                var refinementUrl = $(this).data('href').replace(/(srule=).*?(&|$)/,'$1' + sortingRule + '$2');
            } else if (!$(this).data('href').includes('srule') && sortingRule != null) {
                var split = $(this).data('href').indexOf('?') !== -1 ? '&' : '?';
                var refinementUrl = $(this).data('href') + split + 'srule=' + sortingRule;
            } else {
                var refinementUrl = $(this).data('href');
            }

            event.preventDefault();
            event.stopPropagation();
            $(this).trigger('search:filter', event);

            // Cancel previous request
            $xhr && $xhr.abort && $xhr.abort();

            $xhr = $.ajax({
                url: refinementUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: refinementUrl
                },
                method: 'GET',
                timeout: 10000,
                beforeSend: function () {
                    $.spinner().start();
                },
                success: function (response) {
                    module.exports.methods.parseResults(response);
                    $('body').trigger('search:filter--success');
                },
                complete: function () {
                    $.spinner().stop();
                }
            });
        });
};

core.sort = function () {
    $('.sort-order').each(function () {
        //Track current selection
        var newSelection;
        if ($(this).hasClass('custom-select')) {
            newSelection = this.selectedOptions[0]; // tracking the element to set active
        } else {
            newSelection = $(this);
        }
        $(this).data('sortValueOption', newSelection);
    });

    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        handleSort(this);
    });

    $('.container').on('click', '.sort-order-desktop', function (e) {
        e.preventDefault();
        e.stopPropagation();

        handleSort(this);
    });
}

core.initialize = () => $(document).ready(function () {
  var isMobile = window.isMobile();
  var collapseMobile = $('[data-collapse-mobile]').attr('data-collapse-mobile') === 'true' ? true : false;
  var collapseDesktop = $('[data-collapse-desktop]').attr('data-collapse-desktop') === 'true' ? true : false;
  if (isMobile && collapseMobile) {
      core.setRefinementCollapseStates('close');
  } else if (isMobile && !collapseMobile) {
      core.setRefinementCollapseStates('open');
  } else if (!isMobile && collapseDesktop) {
      core.setRefinementCollapseStates('close');
  } else if (!isMobile && !collapseDesktop) {
      core.setRefinementCollapseStates('open');
  }
  if ($('#articles-tab').hasClass('active') && $('#content-search-results').html() === '') {
      getContent($('.content-search'), $('#content-search-results'));
  }
});

module.exports = core;